/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, Renderer2} from '@angular/core';
import {BACKGROUND_COLOR, COLOR_PRIMARY_LIGHT} from '../../_enums/constants';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGIC FUNCTIONS                                                                                       ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(private renderer: Renderer2) {
    this.renderer.setStyle(document.body, BACKGROUND_COLOR, COLOR_PRIMARY_LIGHT);
  }

}
